import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";
import { h3Regular } from "../typography/MuiTypography.style";

export const CardForExternalLinkWrapper = styled.div`
  .button-with-external-link {
    ${h3Regular}
    background-color: transparent;
    color: ${COLORS.cirrus_black_dark};
    border: 1px solid ${COLORS.cirrus_black3};
    height: auto;
    padding: 12px 36px 12px 24px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06);

    .icon-wrapper .icon {
      height: 48px;
      width: 48px;
      margin-right: 14px;
    }

    .open-in-new-tab-icon {
      color: ${COLORS.primary_light_blue};
    }
  }

  .left-content {
    display: flex;
    align-items: center;
  }
`;
